import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ApiService} from "@ctms/api.service";
import {Chapter, WeeklySummary} from "@shared/api/models/query/patient-statistics.model";
import {FullProgrammeModalComponent} from '@cdss/pages/patient-overview-v2/detail/weekly/components/full-programme-modal.component';
import {ChapterDetailModalComponent} from '@cdss/pages/patient-overview-v2/detail/weekly/components/chapter-detail-modal.component';

@Component({
    selector: 'cdss-patient-overview-v2-chapter-progress',
    imports: [CommonModule],
    providers: [ApiService],
    standalone: true,
    templateUrl: './patient-overview-v2-chapter-progress.component.html',
    styleUrl: './patient-overview-v2-chapter-progress.component.scss',
})
export class PatientOverviewV2ChapterProgressComponent {
    loading = false;

    @Input() type = 'patient';
    @Input() careProgramId: number | null = null;
    private _weeklySummary: WeeklySummary
    disabled: boolean = false

    @Input()
    set weeklySummary(weeklySummary: WeeklySummary) {
        this._weeklySummary = weeklySummary
        this.disabled = !weeklySummary || weeklySummary.chapters.length === 0
    }
    get weeklySummary(): WeeklySummary {
        return this._weeklySummary
    }

    constructor(
        public toastr: ToastrService,
        private modalService: NgbModal,
    ) {
    }

    openFullProgramme(): void {
        if (!this.careProgramId) return;
        const ref = this.modalService.open(FullProgrammeModalComponent, {centered: true, size: 'xl'});
        ref.componentInstance.careProgramId = this.careProgramId;
    }

    openInfo(chapter: Chapter): void {
        if (!chapter.id || !this.careProgramId) return;
        const ref = this.modalService.open(ChapterDetailModalComponent, {centered: true});
        ref.componentInstance.userCareProgramId = this.careProgramId;
        ref.componentInstance.moduleId = chapter.id;
    }
}
